<nz-modal nzTitle="SST Return Declaration Info" [(nzVisible)]="isVisible.submit" nzClosable="false"
  nzMaskClosable="false" (nzOnCancel)="cancel()" (nzOnOk)="submitSST()" nzOkText="Submit SST Return"
  [nzOkDisabled]="form.invalid">

  <ng-container *nzModalContent>
    <form nz-form [formGroup]="form" [nzLayout]="'vertical'" se-container="1" nzSize="small">

      <se-container class="sst-return-declaration-info-modal">
        <nz-row nzGutter="8">
          <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <se label="Declaration Date" required>
              <nz-date-picker formControlName="date" [nzFormat]="dateFormat"></nz-date-picker>
            </se>
          </nz-col>

          <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <se label="Name of Declarant" required>
              <input nz-input formControlName="name" />
            </se>
          </nz-col>

          <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <se label="Identity Card / Passport No." required>
              <input nz-input formControlName="identityNo" />
            </se>
          </nz-col>

          <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <se label="Designation of Declarant" required>
              <input nz-input formControlName="designation" />
            </se>
          </nz-col>

          <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <se label="Telephone No." required>
              <input nz-input #phoneNo formControlName="phoneNo" maxlength="20" app-mobile-input
                [allowDialCode]="true" />
            </se>
          </nz-col>
        </nz-row>

      </se-container>
    </form>
  </ng-container>
</nz-modal>

<nz-modal nzTitle="SST Return Audit Trail Data Item" [(nzVisible)]="isVisible.unlock" nzClosable="false"
  nzMaskClosable="false" (nzOnCancel)="cancel()" (nzOnOk)="unlockSST()" nzOkText="Unlock SST Return">

  <ng-container *nzModalContent>
    <form nz-form [formGroup]="form" [nzLayout]="'vertical'" se-container nzSize="small">

      <se-container>
        <nz-row nzGutter="8">

          <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <se label="Date" required>
              <nz-date-picker formControlName="date" [nzFormat]="dateFormat + ' HH:mm:ss'"
                [disabled]="true"></nz-date-picker>
            </se>
          </nz-col>

          <nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <se label="Reason for Unlocking" required>
              <textarea nz-input formControlName="notes" rows="4" required></textarea>
            </se>
          </nz-col>
        </nz-row>
      </se-container>
    </form>
  </ng-container>
</nz-modal>